import React from 'react';
import DOMPurify from 'dompurify';
import { useTranslation } from "react-i18next";
import { useGuideStore } from '../../../store/guideStore';

interface PublishingProgressProps {
  className?: string;
}

const PublishingProgress: React.FC<PublishingProgressProps> = ({ className = '' }) => {
  const { t } = useTranslation();
  const { isPublishing, publishProgress } = useGuideStore();

  if (!isPublishing) {
    return null;
  }

  return (
    <div className={`rounded-xl bg-white p-4 border-2 border-gray-300 sm:p-6 w-10/12 mx-auto ${className}`}>
      <div className="flex items-start sm:gap-8">
        <div className="w-full">
          <h3 className="mt-2 mb-4 text-lg font-medium">
            {publishProgress?.title || t('guide.publishingProgress.starting')}
          </h3>
          {publishProgress?.description && (
            <p className="mt-1 text-sm text-gray-700" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(publishProgress.description) }}></p>
          )}
          <div className="w-full animate-pulse bg-gray-200 rounded-full dark:bg-gray-700">
            <div
              className="bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full transition-all duration-500 ease-out"
              style={{ width: `${Math.max(publishProgress?.progress || 10, 10)}%` }}
            >
              {Math.max(publishProgress?.progress || 10, 10)}%
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublishingProgress;
